import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c0e54c80 = () => interopDefault(import('../pages/apps/index.vue' /* webpackChunkName: "pages/apps/index" */))
const _010f6176 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _9775f694 = () => interopDefault(import('../pages/changePassword.vue' /* webpackChunkName: "pages/changePassword" */))
const _194febea = () => interopDefault(import('../pages/loyalty.vue' /* webpackChunkName: "pages/loyalty" */))
const _99e53424 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _5bfae506 = () => interopDefault(import('../pages/stores.vue' /* webpackChunkName: "pages/stores" */))
const _fcc6fdd0 = () => interopDefault(import('../pages/account/delete.vue' /* webpackChunkName: "pages/account/delete" */))
const _8c8e9570 = () => interopDefault(import('../pages/auth/verifyRegister.vue' /* webpackChunkName: "pages/auth/verifyRegister" */))
const _a3a543e8 = () => interopDefault(import('../pages/order/cart.vue' /* webpackChunkName: "pages/order/cart" */))
const _1e386332 = () => interopDefault(import('../pages/order/checkout.vue' /* webpackChunkName: "pages/order/checkout" */))
const _0a046b4c = () => interopDefault(import('../pages/order/logistic.vue' /* webpackChunkName: "pages/order/logistic" */))
const _4771e0ca = () => interopDefault(import('../pages/order/payment.vue' /* webpackChunkName: "pages/order/payment" */))
const _359eb361 = () => interopDefault(import('../pages/order/thankyou.vue' /* webpackChunkName: "pages/order/thankyou" */))
const _0c9c9cfc = () => interopDefault(import('../pages/order/tracker.vue' /* webpackChunkName: "pages/order/tracker" */))
const _0651efd7 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _a9bdda4c = () => interopDefault(import('../pages/menu/product/_.vue' /* webpackChunkName: "pages/menu/product/_" */))
const _69e5231e = () => interopDefault(import('../pages/menu/deal/_.vue' /* webpackChunkName: "pages/menu/deal/_" */))
const _41d962fa = () => interopDefault(import('../pages/menu/_.vue' /* webpackChunkName: "pages/menu/_" */))
const _2aacbb09 = () => interopDefault(import('../pages/info/_.vue' /* webpackChunkName: "pages/info/_" */))
const _5307f764 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apps",
    component: _c0e54c80,
    name: "apps"
  }, {
    path: "/auth",
    component: _010f6176,
    name: "auth"
  }, {
    path: "/changePassword",
    component: _9775f694,
    name: "changePassword"
  }, {
    path: "/loyalty",
    component: _194febea,
    name: "loyalty"
  }, {
    path: "/profile",
    component: _99e53424,
    name: "profile"
  }, {
    path: "/stores",
    component: _5bfae506,
    name: "stores"
  }, {
    path: "/account/delete",
    component: _fcc6fdd0,
    name: "account-delete"
  }, {
    path: "/auth/verifyRegister",
    component: _8c8e9570,
    name: "auth-verifyRegister"
  }, {
    path: "/order/cart",
    component: _a3a543e8,
    name: "order-cart"
  }, {
    path: "/order/checkout",
    component: _1e386332,
    name: "order-checkout"
  }, {
    path: "/order/logistic",
    component: _0a046b4c,
    name: "order-logistic"
  }, {
    path: "/order/payment",
    component: _4771e0ca,
    name: "order-payment"
  }, {
    path: "/order/thankyou",
    component: _359eb361,
    name: "order-thankyou"
  }, {
    path: "/order/tracker",
    component: _0c9c9cfc,
    name: "order-tracker"
  }, {
    path: "/",
    component: _0651efd7,
    name: "index"
  }, {
    path: "/menu/product/*",
    component: _a9bdda4c,
    name: "menu-product-all"
  }, {
    path: "/menu/deal/*",
    component: _69e5231e,
    name: "menu-deal-all"
  }, {
    path: "/menu/*",
    component: _41d962fa,
    name: "menu-all"
  }, {
    path: "/info/*",
    component: _2aacbb09,
    name: "info-all"
  }, {
    path: "/*",
    component: _5307f764,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
